import { html, TemplateResult } from 'lit';
import { msg } from '@lit/localize';
import { systemChevronLeft, systemCross } from '@dertour/ui-components/icons';
import { renderDialogBody, type DialogBodyTemplateOptions } from './dialog-body.js';

export interface DialogTemplateOptions extends DialogBodyTemplateOptions {
    onBackClick: () => void;
    onCloseClick: () => void;
    onClose: () => void;
}

export const renderDialog = (options: DialogTemplateOptions): TemplateResult => {
    const showBackButton = options.modalContent === 'booking-request';

    return html`
        <dialog id="der-tm-roundtrip-stage-dialog" @close=${options.onClose}>
            <div class="der-tm-roundtrip-stage__dialog-content">
                <div class="der-tm-roundtrip-stage__dialog-header">
                    ${showBackButton
                        ? html`
                              <button
                                  class="der-tm-roundtrip-stage__dialog-back"
                                  @click=${options.onBackClick}
                                  aria-label=${msg('Zurueck zum Kalender', { desc: 'Dialog back to calendar label' })}
                              >
                                  ${systemChevronLeft({ width: '40px', height: '40px' })}
                                  <span class="der-tm-roundtrip-stage__dialog-back-text">
                                      ${msg('Zurueck', { desc: 'Dialog back button text' })}
                                  </span>
                              </button>
                          `
                        : html``}
                    <button
                        class="der-tm-roundtrip-stage__dialog-close"
                        @click=${options.onCloseClick}
                        aria-label=${msg('Schliessen', { desc: 'Dialog close label' })}
                    >
                        ${systemCross({ width: '40px', height: '40px' })}
                    </button>
                </div>
                <div class="der-tm-roundtrip-stage__dialog-body">${renderDialogBody(options)}</div>
            </div>
        </dialog>
    `;
};
